/**
 * 当たり判定計算用
 */
export class GeometryTest {
    /**
     * ref: ゲーム3D数学 12.16 光線と三角形の交差
     */
    static rayTriangleIntersect(ray, maxDistance = Number.MAX_SAFE_INTEGER, p0, p1, p2, minT = 1) {
        const origin = ray.origin;
        const delta = ray.direction.clone().normalize().multiplyScalar(maxDistance);
        const kNoIntersection = Number.MAX_SAFE_INTEGER;
        // 時計回りエッジベクトル
        const e1 = p1.clone().sub(p0);
        const e2 = p2.clone().sub(p1);
        // 法線
        const n = e1.clone().cross(e2);
        // レイと法線の勾配
        const dot = n.clone().dot(delta);
        // Rayが面に向かっていない場合、失敗（Ray・法線 が正だったら裏向き）
        if (!(dot < 0)) {
            return kNoIntersection;
        }
        // 平面の方程式 Ax + By + Cz = d
        const d = n.dot(p0);
        let t = d - n.dot(origin);
        // Rayの原点がポリゴンの裏側にある
        if (!(t <= 0)) {
            return kNoIntersection;
        }
        if (!(t >= dot * minT)) {
            return kNoIntersection;
        }
        t /= dot;
        const p = origin.clone().add(delta.clone().multiplyScalar(t));
        let u0, u1, u2;
        let v0, v1, v2;
        if (Math.abs(n.x) > Math.abs(n.y)) {
            if (Math.abs(n.x) > Math.abs(n.z)) {
                u0 = p.y - p0.y;
                u1 = p1.y - p0.y;
                u2 = p2.y - p0.y;
                v0 = p.z - p0.z;
                v1 = p1.z - p0.z;
                v2 = p2.z - p0.z;
            }
            else {
                u0 = p.x - p0.x;
                u1 = p1.x - p0.x;
                u2 = p2.x - p0.x;
                v0 = p.y - p0.y;
                v1 = p1.y - p0.y;
                v2 = p2.y - p0.y;
            }
        }
        else {
            if (Math.abs(n.y) > Math.abs(n.z)) {
                u0 = p.x - p0.x;
                u1 = p1.x - p0.x;
                u2 = p2.x - p0.x;
                v0 = p.z - p0.z;
                v1 = p1.z - p0.z;
                v2 = p2.z - p0.z;
            }
            else {
                u0 = p.x - p0.x;
                u1 = p1.x - p0.x;
                u2 = p2.x - p0.x;
                v0 = p.y - p0.y;
                v1 = p1.y - p0.y;
                v2 = p2.y - p0.y;
            }
        }
        let temp = u1 * v2 - v1 * u2;
        if (!(temp !== 0)) {
            return kNoIntersection;
        }
        temp = 1 / temp;
        // 銃身座標の計算
        const alpha = (u0 * v2 - v0 * u2) * temp;
        if (!(alpha >= 0)) {
            return kNoIntersection;
        }
        const beta = (u1 * v0 - v1 * u0) * temp;
        if (!(beta >= 0)) {
            return kNoIntersection;
        }
        const gamma = 1 - alpha - beta;
        if (!(gamma >= 0)) {
            return kNoIntersection;
        }
        return t;
    }
}
//# sourceMappingURL=GeometryTest.js.map